const initialState = {
  fleetId: null,
  fleet: null,
  devices: [],
  selectedSchedulerFleet: null,
};

export default function schedulersReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SELECTED_SCHEDULAR_FLEET": {
      state = {
        ...state,
        selectedSchedulerFleet: action.payload,
      };
      return state;
    }
    case "SET_SCHEDULAR_DEVICES": {
      state = {
        ...state,
        devices: action.payload,
      };
      return state;
    }
    default:
      return state;
  }
}
